import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ObjectSchema } from "yup";

import {
  errors,
  ICatchARideAvailability,
  isBeforeTimeString,
  isValidTimeString,
  TTimeHHmm,
  yupLocalized,
} from "@ryde/shared";

const isTimeOrderValid = (
  from: string | null | undefined,
  to: string | null | undefined,
): boolean => {
  if (!isValidTimeString(from) || !isValidTimeString(to)) {
    return true;
  }

  return isBeforeTimeString(from as TTimeHHmm, to as TTimeHHmm);
};

/** Both time bounds are optional; when both are present the window must not wrap midnight (backend matches from <= start <= to). */
export const useCatchARideAvailabilityItemResolver = () => {
  const { t } = useTranslation();

  const catchARideAvailabilityInnerFormValidationSchema: ObjectSchema<
    Partial<ICatchARideAvailability>
  > = useMemo(() => {
    return yupLocalized.object<Partial<ICatchARideAvailability>>().shape({
      from: yupLocalized
        .string()
        .nullable()
        .test(
          "isBeforeTest",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          (from, ctx) => isTimeOrderValid(from, ctx.parent.to),
        ),
      to: yupLocalized
        .string()
        .nullable()
        .test(
          "isBeforeTest",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          (to, ctx) => isTimeOrderValid(ctx.parent.from, to),
        ),
    }) as ObjectSchema<Partial<ICatchARideAvailability>>;
  }, [t]);

  return { catchARideAvailabilityInnerFormValidationSchema };
};
